var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"userName"},[_vm._v(_vm._s(_vm.mskUserName)+" "),_c('i',{staticClass:"el-icon-caret-bottom"})])
}
var staticRenderFns = []

export { render, staticRenderFns }